module.exports = __webpack_public_path__ + "img/marv-bio-logo.7e8eb443.png";